import { FileType } from "@/Common/Models/FileType";
import { ExportableFilePopupSettings } from "./Settings/ExportableFilePopupSettings";
import { ExportableFilePopupSignatureSettingsModel } from "./ExportableFilePopupSignatureSettingsModel";

class ExportableFilePopupSettingModel {
    public form: ExportableFilePopupSignatureSettingsModel = new ExportableFilePopupSignatureSettingsModel();
    public prescription: ExportableFilePopupSignatureSettingsModel = new ExportableFilePopupSignatureSettingsModel();
    public examRequest: ExportableFilePopupSignatureSettingsModel = new ExportableFilePopupSignatureSettingsModel();
    public consultationRequest: ExportableFilePopupSignatureSettingsModel = new ExportableFilePopupSignatureSettingsModel();

    public constructor(init?: Partial<ExportableFilePopupSettingModel>) {
        Object.assign(this, init);
    }

    public static fromCacheModel(response: ExportableFilePopupSettings): ExportableFilePopupSettingModel {
        if (!response)
            return null;

        return new ExportableFilePopupSettingModel({
            form: ExportableFilePopupSignatureSettingsModel.fromCacheModel(response.Form),
            prescription: ExportableFilePopupSignatureSettingsModel.fromCacheModel(response.Prescription),
            examRequest: ExportableFilePopupSignatureSettingsModel.fromCacheModel(response.ExamRequest),
            consultationRequest: ExportableFilePopupSignatureSettingsModel.fromCacheModel(response.ConsultationRequest)
        });
    }

    public static toCacheModel(settings: ExportableFilePopupSettingModel): ExportableFilePopupSettings {
        return new ExportableFilePopupSettings({
            Form: ExportableFilePopupSignatureSettingsModel.toCacheModel(settings.form),
            Prescription: ExportableFilePopupSignatureSettingsModel.toCacheModel(settings.prescription),
            ExamRequest: ExportableFilePopupSignatureSettingsModel.toCacheModel(settings.examRequest),
            ConsultationRequest: ExportableFilePopupSignatureSettingsModel.toCacheModel(settings.consultationRequest)
        });
    }

    /**
     * Get the settings for a document file type.
     * @param model The model from which to get a settings field.
     * @param type The document file type.
     * @returns The matching field model, or null if none found.
     */
    public static getFieldFor(model: ExportableFilePopupSettingModel, type: FileType): ExportableFilePopupSignatureSettingsModel | null {
        if (model) {
            switch (type) {
                case FileType.Prescription:
                    return model.prescription;

                case FileType.RADPDF:
                    return model.form;

                case FileType.EXAMREQUEST:
                    return model.examRequest;

                case FileType.CONSULTATIONREQUEST:
                    return model.consultationRequest;
            }
        }

        return null;
    }
}

export { ExportableFilePopupSettingModel };
